import React, { useState, useEffect } from 'react';
import api from '../services/api';

const ImportExportPage = () => {
  const [ops, setOps] = useState([]);
  const [fileInputs, setFileInputs] = useState({});
  const [status, setStatus] = useState({});
  useEffect(() => {
    api.get('/import-export').then(res => setOps(res.data)).catch(console.error);
  }, []);
  const downloadFile = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  };
  return (
    <div className="p-6 space-y-6">
      <h2 className="text-2xl mb-4">Import/Export</h2>
      {ops.map(o => (
        <div key={o.id} className="border p-4">
          <h3 className="font-semibold mb-2">{o.name}</h3>
          {o.method === 'POST' ? (
            <>
              <input
                type="file"
                onChange={e => setFileInputs(fi => ({ ...fi, [o.id]: e.target.files[0] }))}
                className="border p-1 mb-2"
              />
              <button
                onClick={() => {
                  const file = fileInputs[o.id];
                  if (!file) return alert('Select a file');
                  const form = new FormData();
                  form.append('file', file);
                  api.post(o.path, form)
                    .then(() => setStatus(st => ({ ...st, [o.id]: 'Success' })))
                    .catch(() => setStatus(st => ({ ...st, [o.id]: 'Failed' })));
                }}
                className="bg-blue-500 text-white px-3 py-1 rounded"
              >Upload</button>
            </>
          ) : (
            <button
              onClick={() => {
                api.get(o.path, { responseType: 'blob' })
                  .then(response => downloadFile(response.data, `${o.id}.csv`))
                  .catch(() => setStatus(st => ({ ...st, [o.id]: 'Failed' })));
              }}
              className="bg-green-500 text-white px-3 py-1 rounded"
            >Download</button>
          )}
          {status[o.id] && <p className="mt-2">{status[o.id]}</p>}
        </div>
      ))}
    </div>
  );
};

export default ImportExportPage;
